class MatchHeight {

    /**
     * @since 4.48.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.selector = '[data-match-height]';
        this.flood;

        // Reroll when the page scrolls
        /*$(window).scroll(() => {
            this.debounce(this.init, 10);
        });*/

        // Run first initialization
        this.init(this);

        // Run again when the page fully loads
        $(window).on('resize', () => this.init(this));
    }

    /**
     * Run a callback through a debouncer for eficiency.
     *
     * @since 4.48.0
     * @method debounce
     * @param callable callback is the callback to use
     * @param int delay is how long to wait between debounce
     * @return void
     */
    debounce(callback, delay) {

        // Clear the internal timer
        clearTimeout(callback._timer);

        // Set a new internal timer
        callback._timer = setTimeout(() => {

            // Run it
            callback(this);

        }, delay);
    }

    /**
     * Initialize the class.
     *
     * @since 4.48.0
     * @method init
     * @return object The initialized map
     */
    init(context) {
        // Normalize our context
        var self = this || context;

        // If there are no countdowns, bail
        if (!$(self.selector).length) return;

        // Declare and initialize
        var matcher = self.match;

        // Listen for the smooth scroll activator
        $(self.selector).each(function (i, c) {

            // Declare and initialize
            let ele      = $(this);
            let target   = $(ele.data('match-height'));
            let images   = 'on' === ele.data('match-height-after-image-load');
            let onlyWhen = ele.data('match-height-only-when');

            // If there is no target, do nothing
            if (!target.length)
                return;

            // Match the height now
            matcher(ele, target, onlyWhen);

            // If we are not re-running after image load, stop here
            if (!images)
                return;

            // Run initialization again after images are loaded
            target.find('img').each((i, e) => {

                // Run the matcher after image load
                $(e).one('load', () => matcher(ele, target, onlyWhen));

            });

        });

        // Prevent leaks
        return;
    }

    /**
     * Match the heights of two given elements.
     *
     * @since 4.48.0
     * @method toggle
     * @param object element is the element to change
     * @param object target is the height to copy
     * @param string onlyWhen is a flag indicating match conditions
     * @return void
     */
    match(element, target, onlyWhen) {

        // Declare and initialize
        let match         = !onlyWhen;
        let elementHeight = element.outerHeight();
        let deviation     = 100;

        // See if it is smaller
        if ('smaller' === onlyWhen)
            match = (elementHeight - deviation) < target.outerHeight();

        // See if it is larger
        if ('larger' === onlyWhen)
            match = (elementHeight + deviation) > target.outerHeight();

        // Match (if applicable)
        if (match)
            element.css('min-height', target.outerHeight());

        // Prevent leaks
        return;
    }
}

export default MatchHeight;